import { Component, OnInit, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { ThemePalette } from '@angular/material';
import { FighterStatus } from '../../cagehunter-core/models/fighter';

@Component({
  selector: 'app-fighter-status-badge',
  template: `
    <mat-chip-list>
      <mat-chip [color]="color" selected>{{ status }}</mat-chip>
    </mat-chip-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FighterStatusBadgeComponent implements OnInit, OnChanges {

  @Input() status: FighterStatus;

  color: ThemePalette;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.status) {
      if (this.status === FighterStatus.ACTIVE) {
        this.color = 'primary';
      } else if (this.status === FighterStatus.DELETED) {
        this.color = 'warn';
      }
    }
  }

}
